import { useAppState } from "./useReduxState"
import { FetchState } from "../Models/Client/FetchState"
import { getItemList, getPageToFetch } from "../Models/Client/RemoteData"
import { Result } from "../Models/Utility/Result"
import { useEffect, useMemo } from "react"
import { useDispatch } from "react-redux"
import { APIAppTemplateModel } from "../Models/API/AppTemplateModel"
import { getTemplateList } from "../Actions/API/AppTemplate/AppTemplateActions"
import { isUserResolve } from "../Helpers/Functions/Selectors/auth"

export function useAppTemplateList(): FetchState<{
    items: APIAppTemplateModel[]
    total: number
}> {
    const dispatch = useDispatch()
    const entry = useAppState(state => state.api.templates)

    const isUserResolvedState = useAppState(isUserResolve)

    useEffect(() => {
        if (!isUserResolvedState || entry?.list !== undefined) {
            return
        }

        const page = getPageToFetch(entry, {})

        if (page >= 0) {
            dispatch(getTemplateList())
        }
    }, [dispatch, entry, isUserResolvedState])

    return useMemo(() => {
        if (entry === undefined || entry.list === undefined) {
            return undefined
        }

        return Result.ok({
            items: getItemList(entry),
            total: entry.list.total
        })
    }, [entry])
}
